'use client'
import { useRouter } from 'next/navigation'
import React, { useState } from 'react'

export default function FormPosts() {
  const [query, setQuery] = useState('')
  const router = useRouter()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    router.push('/todas-noticias?search=' + query)
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <h2 className="pb-4 text-left text-base font-bold uppercase">
          pesquisar
        </h2>
        <div className="bg-blue-gray-50 p-4">
          <input
            type="text"
            placeholder="Pesquisar..."
            className="input input-bordered h-8 w-full rounded-none"
            onChange={(e) => setQuery(e.target.value)}
            value={query}
          />
          <button
            className="absolute -ml-8 p-2"
            type="submit"
            title="Buscar Post"
          >
            <svg
              className="h-4 w-4 text-footer"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
              />
            </svg>
          </button>
        </div>
      </form>
    </>
  )
}
